import React from 'react';

const RangeSliderWithInputs = ({
    min,
    max,
    valueMin,
    valueMax,
    onChange,
    unit,
    step = 1000,
    label
}) => {
    // Basic implementation using two inputs for MVP stability + "premium" styling wrapper
    // A true dual-handle slider in raw React without libs is complex to get perfect accessible UX for.
    // We will stick to refined inputs which are often better for exact budget entry anyway.

    // We can add a simple track visual if needed later.

    const handleMinChange = (e) => {
        const val = e.target.value;
        onChange({ min: val, max: valueMax });
    };

    const handleMaxChange = (e) => {
        const val = e.target.value;
        onChange({ min: valueMin, max: val });
    };

    return (
        <div className="req-range-wrapper">
            {label && <label className="req-label">{label}</label>}
            <div className="req-range-inputs">
                <input
                    type="number"
                    className="req-input"
                    placeholder="Min"
                    value={valueMin || ''}
                    onChange={handleMinChange}
                    style={{ width: '100%' }}
                />
                <span className="req-range-divider">to</span>
                <input
                    type="number"
                    className="req-input"
                    placeholder="Max"
                    value={valueMax || ''}
                    onChange={handleMaxChange}
                    style={{ width: '100%' }}
                />
            </div>
            {unit && <div className="req-label" style={{ alignSelf: 'flex-end', fontSize: '11px' }}>{unit}</div>}
        </div>
    );
};

export default RangeSliderWithInputs;
